import HomeLoginSignUp from "./HomeLoginSignUp";
import { useSelector } from "react-redux";
import Spinner from "utils/Spinner";
import { Navigate } from "react-router-dom";
import QueryChecker from "utils/queryChecker";

const Home = () => {
  const { isAuthenticated, isLoading } = useSelector((store) => store.auth);
  const withQuery = QueryChecker(["promo","email","sId"]);

//  
  if (isLoading)
    return (
      <div className="cs_container h_100 d_flex flex_col align_items_center justify_content_center text_center text_white">
        <Spinner />
      </div>
    );
  if (isAuthenticated) return <Navigate to={"/myAccount/home"+ withQuery} replace />;
  return <HomeLoginSignUp />;
};

export default Home;
